/**
 * Created by wangshhj on 2018/1/10.
 */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import OriginModal from 'bee-modal';
import { getSysFieldid, PubSub, getTopWindow } from '@platform/api';
import { getSafeRandom } from '@platform/api';
import classnames from 'classnames';
require('bee-modal/build/Modal.css');
require('./index.less');

let indexArr = {};
class Modal extends Component {
    constructor(props) {
        super(props);
        this.timer = null;
        this.getDomTimer = null;
        this.state = {};
    }

    componentWillUnmount() {
        this.timer && clearTimeout(this.timer);
        this.getDomTimer && clearTimeout(this.getDomTimer);
        // 没有在modal里subscribe但是却做了unsubscribe
        // 导致modal的modelResizeEnd和MODAL的通知别的组件都接收不到了
        // PubSub.unsubscribe('modelResizeEnd');
        // PubSub.unsubscribe('MODAL');
    }

    changeZIndex = (el, zIndex) => {
        el.style.setProperty('z-index', zIndex);
        let modalBackDrop = el.previousSibling;
        modalBackDrop && modalBackDrop.style.setProperty('z-index', zIndex - 1);
    };

    //从类名获取当前的modal的是否是大中小自适应类型的弹框
    getCustomType = className => {
        if (className) {
            if (className.indexOf('junior') !== -1) {
                return 'junior';
            } else if (className.indexOf('senior') !== -1) {
                return 'senior';
            } else if (className.indexOf('combine') !== -1) {
                return 'combine';
            } else if (className.indexOf('prompt-box') !== -1) {
                return 'prompt-box';
            } else if (className.indexOf('createNcModal') !== -1) {
                return 'createNcModal';
            } else if (className.indexOf('bill-track') !== -1) {
                return 'bill-track';
            } else if (className.indexOf('FormulaEditorWrap') !== -1) {
                return 'formula';
            }
        }
        return '';
    };

    //处理宽高有显示的类型的modal
    getMinHW = type => {
        let info = {};
        if (
            type === 'junior' ||
            type === 'prompt-box' ||
            type === 'createNcModal'
        ) {
            info.height = 201;
            info.width = 410;
        } else if (type === 'senior') {
            info.height = 256;
            info.width = 520;
        } else if (type === 'combine') {
            info.height = 302;
            info.width = 680;
        }
        return info;
    };

    onEscapeKeyUp = () => {
        // esc的時候先關閉  toast提示  然後再執行彈窗的關閉事件  by bbqin
        this.escKeyed = !!(
            document && document.querySelector('.toast-zijinyun-project')
        );
        // console.log(this.escKeyed);
        this.props.onEscapeKeyUp && this.props.onEscapeKeyUp();
    };

    onHide = () => {
        let hasToast = !(
            document && document.querySelector('.toast-zijinyun-project')
        );
        // 由於要兼容  點擊x和esc兩種情況  所有是 ！==true
        (this.escKeyed !== true || hasToast) && this.props.onHide && this.props.onHide();
    };

    /**
     * 判断当前的modal是不是顶层的modal  by bbqin
     */
    isTopModal = () => {
        let referModal = document.querySelector('.refer-pop-window.disabled-bg-btn');

        if (referModal) {
            return false;
        }

        if (this.modal) {
            let modals = this.modal.props.manager.modals;
            return (
                ReactDOM.findDOMNode(this.modal) ===
                ReactDOM.findDOMNode(modals[modals.length - 1])
            );
        }
        return false;
    };

    /**
     * 弹窗完成显示添加自动聚焦焦点的操作
     * @param {*} modalDom
     */
    onEnteredHandle(modalDom) {
        let { modalAutoFocus = true } = this.props;
        let content = modalDom.querySelector('.u-modal-content');
        if (content && modalAutoFocus) {
            let modalBody = content.querySelector('.u-modal-body');
            if (modalBody) {
                modalBody.tabIndex = '0';
                modalBody.focus();
            } else {
                content.tabIndex = '0';
                content.focus();
            }

            // let { size } = this.props;
            // if (size == 'max') {
            //   //1909定制最大尺寸弹框
            //   if (content.parentElement) {
            //     // content.parentElement.style.height = document.body.offsetHeight - 16 + 'px';
            //   }
            // }
        }
        // let modalDialog = modalDom.querySelector('.u-modal-dialog');
        // this.setState({
        //   bounds: {
        //     top: -(modalDialog.offsetTop),
        //     bottom: document.body.offsetHeight - modalDialog.offsetTop - modalDialog.offsetHeight //总高度-距离上边高度-modal高度
        //   }
        // });
        this.props.onEntered && this.props.onEntered(modalDom);
    }

    /**
     * 显示开始
     */
    onEnterHandle(modalDom) {
        // 解决表格内焦点回执的问题  暂时方案 TODO
        // this.prevActiveElement = null;
        modalDom.id = this.props.id
        this.prevActiveElement = document.activeElement;

        let { className, resizable, bodyHeight, size } = this.props;
        let content = modalDom.querySelector('.u-modal-content');
        if (content) {
            let modalBody = content.querySelector('.u-modal-body');
            let customType = this.getCustomType(className);
            if (modalBody) {
                //给王印（孙泽光部门）加可以设置模态框高度属性
                if (bodyHeight) {
                    modalBody.style.height = bodyHeight;
                } else if (customType) {
                    if (customType === 'bill-track') {
                        modalBody.style.maxHeight =
                            document.body.offsetHeight - 40 - 60 + 'px';
                    } else {
                        modalBody.classList &&
                            modalBody.classList.add(
                                `u-modal-${customType}-body`,
                            );
                    }
                } else if (size == 'max') {
                    modalBody.style.height = document.body.offsetHeight - 32 - 40 - 44 + 'px';

                } else {
                    //给非定制类型的modal设置最大高度 可视区高度减去nc-modal的padding、u-modal-body的padding、
                    //modalHeader的高度、modalFooter的高度  上下margin的高度
                    modalBody.style.maxHeight =
                        document.body.offsetHeight - 32 - 40 - 44 - 60 + 'px';
                }
            }
            try {
                if (resizable !== false) {
                    content.parentElement.parentElement.classList.add(
                        'modal-content-resizeWrap-parent',
                    );
                } else {
                    content.parentElement.classList.add(
                        'modal-content-parent',
                    );
                }
            } catch (err) { console.log(err); }
        }
        this.props.onEnter && this.props.onEnter();
    }

    /**
     * 显示中
     */
    // onEnteringHandle = (dom) => {
    // let resizeDom = dom.querySelector('.modal-content-resizeWrap');
    // if (!resizeDom) {
    //   return;
    // }
    // let pageHeight = document.body.offsetHeight;
    // let modalHeight = resizeDom.offsetHeight;
    // let forCenterHeight = pageHeight / 2 - modalHeight / 2;
    // resizeDom.style.transform = `translate(0px,${forCenterHeight}px)`;
    // }

    /**
     * 隐藏结束
     */
    onExitedHandle() {
        let { focusBody = true } = this.props;
        if ((!this.prevActiveElement || !this.prevActiveElement.parentElement) && focusBody) {
            // 如果父级不存在 说明消失了 焦点到body上
            document && document.body.focus();
        }
        this.props.onExited && this.props.onExited();
    }

    /**
     * resize结束时的回调
     * 处理大中小三种类型弹框配置拖拽之后的出现的问题
     */
    // 三个参数 e, dir, elementRef
    onResizeStopHandle = () => {
        //   let { className, noFooter } = this.props;
        let currentModal = ReactDOM.findDOMNode(this);
        //   if (currentModal) {
        //     // let customType = this.getCustomType(className);
        //     // if (customType) {
        //     this.getDomTimer = setTimeout(() => {
        //       if (!noFooter) {
        //         let modalBody = currentModal.querySelector(`.u-modal-body`);
        //         let modalContent = currentModal.querySelector(`.u-modal-content`);

        //         modalBody.style.height = modalContent.offsetHeight - 46 - 40 + 'px'
        //         modalBody.style.maxHeight = modalContent.offsetHeight - 46 - 40 + 'px'
        //       }

        //       //拖拽modal高度的时候，modalbody上钉耙会设置行间的高度，拖拽宽度的时候不会设置，就会导致modalBodyFirstChild元素就获取不到原来的高度
        //       // let modalBodyFirstChild = currentModal.querySelector(
        //       //   `.u-modal-${customType}-body`
        //       // );
        //       // if (!modalBodyFirstChild) {
        //       //   modalBodyFirstChild = currentModal.querySelector(
        //       //     `.body-firstchild-resize`
        //       //   );
        //       // }

        //       // if (modalBodyFirstChild && modalBody) {
        //       //   let modalBodyHeight = modalBody.offsetHeight;
        //       //   !modalBodyFirstChild.classList.contains("body-firstchild-resize") &&
        //       //     modalBodyFirstChild.classList.add("body-firstchild-resize");
        //       //   !modalBodyFirstChild.classList.contains(
        //       //     `u-modal-${customType}-body`
        //       //   ) &&
        //       //     modalBodyFirstChild.classList.remove(
        //       //       `u-modal-${customType}-body`
        //       //     );
        //       //   // modalBodyFirstChild.style.height = modalBodyHeight + "px";
        //       //   // modalBodyFirstChild.style.maxHeight = modalBodyHeight + "px";
        //       // }
        //     });
        //     // }
        //   }
        let { onResizeStop, indexInfo, className, id } = this.props;
        onResizeStop && onResizeStop();
        PubSub.publish('modelResizeEnd', { indexInfo, className, id });
        PubSub.publish('MODAL', { sence: 'modal', currentModal });
    };

    /**
      * resize开始时的回调
      * 去掉大中小三种类型弹框配置的最大，最大宽度
      */
    onResizeStartHandle = () => {
        let { className } = this.props;
        let currentModal = ReactDOM.findDOMNode(this);
        if (currentModal) {
            let modalBody = currentModal.querySelector('.u-modal-body');
            if (modalBody) {
                let customType = this.getCustomType(className);
                modalBody.style.height = modalBody.offsetHeight + 'px';
                modalBody.style.maxHeight = 'none'; // 去除一下最大高度 避免出现问题
                modalBody.classList.remove(`u-modal-${customType}-body`);
            }
        }
    }

    /**
     * 多个modal显示的层级管理
     * ModalArr在body下ModalArr组成的数组
     */
    modalIndexManager = ModalArr => {
        Array.from(ModalArr).forEach((el, index) => {
            for (let attr in indexArr) {
                if (el.classList.contains(attr)) {
                    let newIndex = index;
                    if (
                        (el.classList.contains('prompt-box') ||
                            el.classList.contains('createNcModal')) &&
                        Number(indexArr[attr]) === 200
                    ) {
                        newIndex = Number(index) + 131;//231改成131,如果有问题再让陈道诚改 NCC-75445这个问题
                    }
                    let zIndex = Number(indexArr[attr]) + Number(newIndex) + 2;
                    this.changeZIndex(ModalArr[index], zIndex);
                    // }
                }
            }
        });
    };

    render() {
        let {
            className,
            backdropStyle,
            indexInfo,
            zIndex = 200,
            onEscapeKeyUp,
            onHide,
            onExited,
            onEnter,
            onEntered,
            fieldid,
            draggable,
            resizable,
            backdrop,
            id,
            ...others
        } = this.props;
        if (id && indexInfo) {
            indexArr[indexInfo.id] = indexInfo.zIndex;
        } else {
            id = this.props.id ? this.props.id : Date.now() + getSafeRandom();
            indexArr[id] = zIndex;
        }
        let customType = this.getCustomType(className);
        let customSizeInfo = this.getMinHW(customType);

        this.timer = setTimeout(() => {
            //多个模态框叠加显示的层级处理
            let ModalArr = document.getElementsByClassName('nc-modal');
            let ModalInTop = getTopWindow().document.getElementsByClassName('nc-modal');
            this.modalIndexManager(ModalArr, id);
            this.modalIndexManager(ModalInTop, id);
        });

        if (fieldid) {
            fieldid = fieldid + '_modal-area';
        }
        if (!fieldid) {
            fieldid = '_modal-area';
        }

        fieldid = getSysFieldid(fieldid);

        //不配置backdrop为true或者false的，默认都是点击遮罩禁止关闭
        if (!backdrop && backdrop !== false) {
            backdrop = 'static';
        }
        let { noFooter } = this.props

        return (
            <OriginModal
                fieldid={fieldid}
                enforceFocus={false}
                atuoFocus={false}
                className={
                    classnames(`${id}`,
                        'nc-modal',
                        'disabled-bg-btn',
                        `${className}`,
                        { 'no-footer': noFooter },
                    )
                }
                backdropStyle={{ ...backdropStyle }}
                backdrop={backdrop}
                ref={modal => (this.modal = modal)}
                onEntered={this.onEnteredHandle.bind(this)}
                onEnter={this.onEnterHandle.bind(this)}
                // onEntering={this.onEnteringHandle}
                onExited={this.onExitedHandle.bind(this)}
                onResizeStop={this.onResizeStopHandle}
                onResizeStart={this.onResizeStartHandle}
                keyboard={true}
                onEscapeKeyUp={this.onEscapeKeyUp.bind(this)}
                onHide={this.onHide.bind(this)}
                width={customSizeInfo.width}
                draggable={draggable === undefined ? true : draggable}
                resizable={resizable === undefined ? true : resizable}
                resizeClassName='modal-content-resizeWrap'
                minHeight={customSizeInfo.height ? customSizeInfo.height : undefined}
                minWidth={customSizeInfo.width ? customSizeInfo.width : undefined}
                {...others}
                centered={true} //会造成拖拽之后立马回到原来位置的问题
                bounds='html'
            />
        );
    }
}

class Header extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let { fieldid, closeButton, ...others } = this.props;
        let closeButtonProps = {};
        if (closeButton) {
            closeButtonProps.fieldid = 'close_btn';
        }

        if (!fieldid) {
            fieldid = 'header-area';
        }
        fieldid = getSysFieldid(fieldid);
        return (
            <OriginModal.Header fieldid={fieldid} closeButtonProps={closeButtonProps} closeButton={closeButton} {...others}>
                <img
                    className="modal-header-img"
                    //src='../../static/images/modal-img.png'
                    src={require('../../static/images/modal-img.png')}
                />
                {this.props.children}
            </OriginModal.Header>
        );
    }
}

class Title extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let { fieldid, ...others } = this.props;

        //传了fieldid使用传的内容做标记
        if (fieldid) {
            fieldid = fieldid + '_title';
        } else {
            // 业务组未传fieldid的,使用children作为标记
            fieldid =
                typeof this.props.children === 'string'
                    ? `${this.props.children}_title`
                    : '_title';
        }
        fieldid = getSysFieldid(fieldid);

        return (
            <OriginModal.Title {...others} fieldid={fieldid}>
                {this.props.children}
            </OriginModal.Title>
        );
    }
}

class Body extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <OriginModal.Body {...this.props}>
                {this.props.children}
            </OriginModal.Body>
        );
    }
}

class Footer extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let { fieldid, ...others } = this.props;
        if (!fieldid) {
            fieldid = 'bottom-area';
        }
        fieldid = getSysFieldid(fieldid);
        return <OriginModal.Footer {...others} fieldid={fieldid} />;
    }
}

Modal.Header = Header;
Modal.Title = Title;
Modal.Body = Body;
Modal.Footer = Footer;

export default Modal;

// Modal.Header = Modal.Header;
// Modal.Title = Modal.Title;
// Modal.Body = Modal.Body;
// Modal.Footer = Modal.Footer;
